import React, { useState } from 'react';
import {
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Select,
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  InputLabel,
  FormControl
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { useLocation, useNavigate } from 'react-router';
import { TerminalMappingApi, TerminalMappingApiEdit } from 'API/Services';

const Details = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const StateData = location.state;
  const [Data, setData] = useState({});
  const [Success, setSuccess] = useState(false);
  const [ErrorRes, setErrorRes] = useState(false);
  const [Error, setError] = useState({
    csp_code: false,
    terminal_id: false,
    connectivity_type: false,
    mapping_date: false,
    fingerprint_capture_date: false
  });
  const [IsLoading, setIsLoading] = useState(false);

  const [ErrMessage, setErrMessage] = useState('');
  const handleChange = (name, event) => {
    setData({ ...Data, [name]: event });
    setError({ ...Error, [name]: false });
  };
  const handleSubmit = () => {
    if (StateData.type === 'create') {
      // if (!Data.csp_code) {
      //   setError({ ...Error, csp_code: true });
      //   setErrMessage('This field is required');
      // } else
      if (!Data.terminal_id) {
        setError({ ...Error, terminal_id: true });
        setErrMessage('Terminal id is required');
      } else if (!Data.connectivity_type) {
        setError({ ...Error, connectivity_type: true });
        setErrMessage('Connectivity type is required');
      } else if (!Data.mapping_date) {
        setError({ ...Error, mapping_date: true });
        setErrMessage('Terminal mapping date is required');
      } else if (!Data.fingerprint_capture_date) {
        setError({ ...Error, fingerprint_capture_date: true });
        setErrMessage('Finger print capture date is required');
      } else {
        TerminalMappingApi(setIsLoading, Data, StateData, setSuccess, setErrorRes);
      }
    } else {
      if (!Data.csp_code) {
        setError({ ...Error, csp_code: true });
        setErrMessage('Csp code is required');
      } else if (!Data.terminal_id) {
        setError({ ...Error, terminal_id: true });
        setErrMessage('Terminal id is required');
      } else if (!Data.connectivity_type) {
        setError({ ...Error, connectivity_type: true });
        setErrMessage('Connectivity type is required');
      } else if (!Data.mapping_date) {
        setError({ ...Error, mapping_date: true });
        setErrMessage('Terminal mapping date is required');
      } else if (!Data.fingerprint_capture_date) {
        setError({ ...Error, fingerprint_capture_date: true });
        setErrMessage('Finger print capture date is required');
      } else {
        TerminalMappingApiEdit(setIsLoading, StateData, Data, handleError, handleClick, setSuccess, setErrorRes);
      }
    }
  };

  const handleClick = () => {
    setSuccess(true);
    setTimeout(() => {
      Navigate(-1);
    }, 2000);
  };
  const handleError = () => {
    setErrorRes(true);
  };

  const handleResClose = () => {
    setErrorRes(false);
    setSuccess(false);
  };
  const handleInput = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, '');
    if (value.length > 20) {
      value = value.slice(0, 20);
    }
    e.target.value = value;
  };
  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Alert start */}
      <Snackbar open={Success} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleResClose}>
        <Alert severity="success" variant="filled" sx={{ width: '100%' }} onClose={handleResClose}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar open={ErrorRes} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleResClose}>
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleResClose}>
          {ErrorRes}
        </Alert>
      </Snackbar>
      <SubCard title="Terminal Mapping">
        <Grid container spacing={2} xl={12}>
          <Grid item xl={4} lg={4} md={4} xs={6}>
            <TextField
              id="outlined-basic"
              error={Error.csp_code}
              fullWidth
              value={Data.csp_code ? Data.csp_code : StateData ? StateData.code : ''}
              label="Csp Code"
              variant="outlined"
              name="csp_code"
              onChange={(e) => handleChange('csp_code', e.target.value)}
              inputProps={{
                readOnly: StateData && StateData.code
              }}
              sx={{
                input: {
                  background: '#f0f0f0'
                }
              }}
            />
            <Typography display={Error.csp_code ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
              {ErrMessage}
            </Typography>
          </Grid>
          <Grid item xl={4} lg={4} md={4} xs={6}>
            <TextField
              id="outlined-basic"
              error={Error.terminal_id}
              fullWidth
              value={Data.terminal_id ? Data.terminal_id : StateData ? StateData.terminal_id : ''}
              // disabled={DisableNumber ? DisableNumber : false}
              label="Terminal ID"
              variant="outlined"
              name="terminal_id"
              onChange={(e) => handleChange('terminal_id', e.target.value)}
              onInput={handleInput}
              inputProps={{
                readOnly: StateData && StateData.terminal_id
              }}
              // sx={{
              //   input: {
              //     background: StateData&&StateData.terminal_id?'#f0f0f0':'#FFFFF2'
              //   }
              // }}
            />
            <Typography display={Error.terminal_id ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
              {ErrMessage}
            </Typography>
          </Grid>
          <Grid item xl={4} lg={4} md={4} xs={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Connectivity Type</InputLabel>
              <Select
                labelid="demo-simple-select-label"
                id="demo-simple-select"
                error={Error.connectivity_type}
                value={Data.connectivity_type ? Data.connectivity_type : StateData ? StateData.type : 'select'}
                name="connectivity_type"
                label="Connectivity Type"
                onChange={(e) => handleChange('connectivity_type', e.target.value)}
              >
                <MenuItem value={'select'} disabled>
                  select
                </MenuItem>
                <MenuItem value={'Dongle'}>Dongle</MenuItem>
                <MenuItem value={'Broadband'}>Broadband</MenuItem>
                <MenuItem value={'WIFI'}>WIFI</MenuItem>
              </Select>
            </FormControl>
            <Typography display={Error.connectivity_type ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
              {ErrMessage}
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid container spacing={2} xl={12} mt={1}> */}
        {/* </Grid> */}
        <Grid container spacing={2} xl={12} sx={{ mt: 1 }}>
          <Grid item xl={3} lg={6} md={4} xs={6}>
            <InputLabel sx={{ mb: '10px' }}>Terminal Mapping Date</InputLabel>
            <TextField
              id="outlined-basic"
              error={Error.mapping_date}
              fullWidth
              value={Data.mapping_date ? Data.mapping_date : StateData ? StateData.map_date : ''}
              //   label="Code Creation Date"
              // disabled={DisableEmail ? DisableEmail : false}
              type="date"
              variant="outlined"
              name="mapping_date"
              onChange={(e) => handleChange('mapping_date', e.target.value)}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split('T')[0] // Setting max to today
                }
              }}
            />
            <Typography display={Error.mapping_date ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
              {ErrMessage}
            </Typography>
          </Grid>
          <Grid item xl={3} lg={6} md={4} xs={6}>
            <InputLabel sx={{ mb: '10px' }}>Finger Print Capture Date</InputLabel>
            <TextField
              id="outlined-basic"
              error={Error.fingerprint_capture_date}
              fullWidth
              value={Data.fingerprint_capture_date ? Data.fingerprint_capture_date : StateData ? StateData.fingerprint_date : ''}
              //   label="Code Creation Date"
              // disabled={DisableEmail ? DisableEmail : false}
              type="date"
              variant="outlined"
              name="fingerprint_capture_date"
              onChange={(e) => handleChange('fingerprint_capture_date', e.target.value)}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split('T')[0] // Setting max to today
                }
              }}
            />
            <Typography display={Error.fingerprint_capture_date ? 'block' : 'none'} color="error" sx={{ mt: 1 }}>
              {ErrMessage}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xl={3} lg={3} md={3} xs={12} display="flex" justifyContent="center" mt={4}>
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              width: '10%',
              marginRight: '15px',
              borderColor: '#688B2A',
              color: '#688B2A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B2A'
              }
            }}
            onClick={() => Navigate(-1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              width: '10%',
              backgroundColor: '#688B2A',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </SubCard>
    </>
  );
};

export default Details;
